import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PrimaryButton from "../UI/Buttons/PrimaryButton";
import Footer from "./Footer";
import Header from "./Header";

import Style from "./Layout.module.css";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import useScreenSize from "../../hooks/useScreenSize";
import { useLocation } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";

const Layout = ({ children }) => {
  const { isExtraSmallSize, isLargeSize } = useScreenSize();
  const location = useLocation();
  const { copy } = useI18n();
  const showFloatingMeetingButton =
    !isLargeSize && location.pathname !== "/wecp";

  return (
    <div className={Style.layout}>
      <Header />
      {showFloatingMeetingButton && (
        <PrimaryButton
          onClick={() =>
            window.open("https://calendly.com/contact-warenex/30min")
          }
          ariaLabel={copy.common.bookMeeting}
          title={isExtraSmallSize ? copy.common.bookMeeting : undefined}
          style={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            zIndex: 9999,
            opacity: "0.85",
            justifyContent: isExtraSmallSize ? "center" : "space-between",
            width: isExtraSmallSize ? "4.8rem" : "12.5rem",
            height: isExtraSmallSize ? "4.8rem" : undefined,
            padding: isExtraSmallSize ? 0 : undefined,
            borderRadius: "5px",
          }}
        >
          {!isExtraSmallSize && (
            <span style={{ width: "68%", display: "flex" }}>
              {copy.common.bookMeeting}
            </span>
          )}
          <FontAwesomeIcon icon={faCalendarDays} color="#fff" size="lg" />
        </PrimaryButton>
      )}

      <main className={Style.main}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
